import React from 'react';
// import PropTypes from 'prop-types';
import { Button, Grid } from '@material-ui/core';
import { Field, reduxForm } from 'redux-form';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import CaptchaForm from '../Complements/CaptchaForm';
//import RenderTextFieldMask from '../Complements/RenderTextFIeldMask';
import { history } from '../../helpers/history';
//import { buttonsStyles } from '../../styles/LoginTheme';
import { makeStyles } from '@material-ui/core/styles';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';

const useStyles = makeStyles(theme => ({

    submit: {
        [theme.breakpoints.up('xs')]: {
            fontSize: '60%',
            color: '#1a1919',
            borderRadius: '0px',
            borderLeft: '3px solid #014587',
            backgroundColor: "white",
            //fontFamily: 'Ubuntu',
            "&:hover": {
                backgroundColor: "white"
            }
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '100%',
            color: '#1a1919',
            borderLeft: '3px solid #014587',
            backgroundColor: "white",
            //fontFamily: 'Ubuntu',
            "&:hover": {
                backgroundColor: "white"
            }
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '100%',
            color: '#1a1919',
            borderLeft: '3px solid #014587',
            backgroundColor: "white",
            //fontFamily: 'Ubuntu',
            "&:hover": {
                backgroundColor: "white"
            }
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '100%',
            color: '#1a1919',
            borderLeft: '3px solid #014587',
            backgroundColor: "white",
            //fontFamily: 'Ubuntu',
            "&:hover": {
                backgroundColor: "white"
            }
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '100%',
            color: '#1a1919',
            borderLeft: '3px solid #014587',
            backgroundColor: "white",
            //fontFamily: 'Ubuntu',
            "&:hover": {
                backgroundColor: "white"
            }
        },
    }
}));

const validate = values => {
    const error  = {}
    if (!values.code) {
        error.code = `El campo es obligatorio`
    }
    if (!values.date) {
      error.date = `El campo es obligatorio`
    }
    if (/^([A-Z]{4})(-)([A-Z]{1})(_)([A-Z]{1,})(-)([0-9]{1,})$/.test(values.code) === false) {
        error.code = "El código debe tener el siguiente formato: CERT-C_CUENACT-1."
    }
    return error
  }
  
const ValidateProcessForm = props => {
    const { handleSubmit, setCertificateData, initialValues, valid } = props
    //const buttonsClass = buttonsStyles()
    const classes = useStyles()
    return (
        <div>
            <form onSubmit={ handleSubmit }>
                <Grid container spacing={3} alignItems = 'center'>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Field
                            required
                            withFocus
                            name="code"
                            id="code"
                            component={ RenderTextFieldRedux }
                            label="Código de certificado"
                            onChange={(e)=> setCertificateData({code: e.target.value, date: initialValues.date})}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Field
                            name="date"
                            
                            component={ ({name, input, ...other}) => <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                                                <KeyboardDatePicker
                                                                    // disableToolbar
                                                                    // variant="inline"
                                                                    {...input}
                                                                    {...other}
                                                                    required
                                                                    fullWidth
                                                                    autoOk
                                                                    variant="inline"
                                                                    format="dd/MM/yyyy"
                                                                    margin="normal"
                                                                    id="date"
                                                                    name = {name}
                                                                    label="Fecha de emision"
                                                                    // value={props.certificateData.date}
                                                                    onChange={(e)=> setCertificateData({code: initialValues.code, date: e})}
                                                                    KeyboardButtonProps={{
                                                                        'aria-label': 'change date',
                                                                    }}
                                                                />
                                                            </MuiPickersUtilsProvider>
                            }
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}></Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <CaptchaForm />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <Button  type="submit"
                            fullWidth
                            disabled={!valid }
                            variant="contained"
                            color="primary"
                            className = { classes.submit }
                            >
                            Validar
                        </Button>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <Button variant="contained" onClick = { () => history.push('/login') } className={ classes.submit } fullWidth>
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    );
};

ValidateProcessForm.propTypes = {
    
};


const ValidateProcessFormRedux = reduxForm(
    {
        form: 'ValidateProcessForm',
        validate
    }
)(ValidateProcessForm)

// export default ChangePasswordForm;
export default setPropsAsInitial(ValidateProcessFormRedux);